import React from 'react';
import classNames from 'classnames';

interface PropTypes {
  digit: number;
  className?: string;
}

export function DigitCircle(props: PropTypes) {
  return (
    <span
      className={classNames(
        'badge',
        'fs-5',
        'rounded-circle',
        'py-2',
        'm-0',
        props.className,
      )}
    >
      {props.digit}
    </span>
  );
}
